 <div class="row">
   <div class="col-lg-12">

     <div class="m-portlet m-portlet--unair">
       <div class="m-portlet__head">
         <div class="m-portlet__head-caption">
           <div class="m-portlet__head-title">
             <span class="top-txt text-color-1 accent-text" [style.fontSize]="fontSize">
               {{title}}
             </span>
             <ng-content></ng-content>
             <!--TODO: move inboxUnreadCount inside ng-content  -->
             <a *ngIf="inboxUnreadCount" class="text-color-1 accent-text" [routerLink]="'../inbox'"
                [queryParams]="{mode: 'unread'}">
               ({{inboxUnreadCount}}) {{'NEW_MESSAGES' | dictionary}}
             </a>
           </div>
         </div>
       </div>


       <div class="m-portlet__body form-box text-color-deep-heading" *ngIf="introText"
           [innerHTML]="introText">
       </div>
     </div>
   </div>

 </div>
